/**
 * Маленький UI-store для панели апгрейдов — позволяет внешним эффектам
 * (например OnboardingDriver) закрывать её программно когда онбординг
 * хочет показать игроку подсветку Искры/счётчика, а полноэкранная панель
 * перекрывает фокус.
 *
 * JB 2026-05-26: «когда происходит тип что от апгрейдов меняется что то
 * вот этот то панель апгрейдов будет логично свернуть».
 */
import { create } from 'zustand';

interface UpgradesUiStore {
  readonly open: boolean;
  setOpen(open: boolean): void;
}

export const useUpgradesUiStore = create<UpgradesUiStore>((set) => ({
  open: false,
  setOpen(open: boolean) {
    set({ open });
  },
}));
